import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Packages
import { Button, Form, Input, Modal, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Components
import ImageUpload from '../../utils/ImageUpload';

// Actions
import { get_all_states, set_state_create_id, state_create, state_update } from '../../../redux/actions/statesActions';
import { form_image_upload } from '../../../redux/actions/utilsActions';

// Utils
import isEmpty from '../../../utils/isEmpty';

const StatesForm = (props) => {
	const { messageApi, ingredientId, isModalStateOpen, setIsModalStateOpen, updateState, stateToUpdate, setStateToUpdate, filters } = props;

	const { t } = useTranslation();

	const dispatch = useDispatch();

	const { state_create_loading, state_id, state_update_loading } = useSelector(state => state.states);

	const [fileList, setFileList] = useState([]);
	const [spriteList, setSpriteList] = useState([]);
	
	const [form] = Form.useForm();

	useEffect(() => {
		if (!isEmpty(stateToUpdate)) {
			form.setFieldsValue(stateToUpdate);
		}
	}, [stateToUpdate]);

	const handleCancel = (finish) => {
		form.resetFields();
		setFileList([]);
		setSpriteList([]);
		setIsModalStateOpen(false);
		dispatch(set_state_create_id(null));
		setStateToUpdate({});

		if (finish) {
			dispatch(get_all_states(filters));
		}
	}

	const onOk = () => {
		form
			.validateFields()
			.then((values) => {
				if (!updateState) {
					// Create
					values.ingredient = ingredientId;
					dispatch(state_create(values));
				}
				else {
					// Update
					dispatch(state_update(messageApi, state_id, values, () => handleCancel(true)));
				}
			})
			.catch((info) => {
				console.error(info);
			});
	}

	return (
		<Modal
			title={!updateState ? t('ingredients.states.create.modalTitle') : t('ingredients.states.edit.modalTitle')}
			centered
			open={isModalStateOpen}
			onCancel={() => handleCancel(false)}
			maskClosable={false}
			width={700}
			footer={[
				<Button
					key='submit'
					type='primary'
					loading={!updateState ? state_create_loading : state_update_loading}
					onClick={state_id && !updateState ? () => handleCancel(true) : onOk}
				>
					{state_id ? t('buttons.finish') : t('buttons.save')}
				</Button>,
			]}
		>
			<Form
				labelCol={{ span: 5 }}
				form={form}
			>
				<Form.Item
					label={t('form.label.name')}
					name='name'
					rules={[
						{
							required: true,
							message: t('form.rules.required'),
						}
					]}
				>
					<Input placeholder={t('form.placeholders.name')} />
				</Form.Item>
				<Form.Item
					label={t('form.label.description')}
					name='description'
					rules={[
						{
							required: true,
							message: t('form.rules.required'),
						}
					]}
				>
					<Input placeholder={t('form.placeholders.description')} />
				</Form.Item>
			</Form>
			{state_id && (
				<Space align='start' size={10}>
					<Typography.Text style={{ marginLeft: '4.3rem' }}>{t('form.label.image')}:</Typography.Text>
					<ImageUpload
						action={process.env.REACT_APP_SERVER_URL + `/api/recipes/states/${state_id}/asset/upload`}
						actionFunction={(options) => dispatch(form_image_upload(options))}
						fileList={fileList}
						setFileList={setFileList}
					/>
					<Typography.Text style={{ marginLeft: '4.3rem' }}>{t('form.label.sprite')}:</Typography.Text>
					<ImageUpload
						action={process.env.REACT_APP_SERVER_URL + `/api/recipes/states/${state_id}/sprite/upload`}
						actionFunction={(options) => dispatch(form_image_upload(options))}
						fileList={spriteList}
						setFileList={setSpriteList}
					/>
				</Space>
			)}
		</Modal>
	)
}

StatesForm.propTypes = {
	messageApi: PropTypes.object.isRequired,
	ingredientId: PropTypes.string.isRequired,
	isModalStateOpen: PropTypes.bool.isRequired,
	setIsModalStateOpen: PropTypes.func.isRequired,
	updateState: PropTypes.bool.isRequired,
	stateToUpdate: PropTypes.object.isRequired,
	setStateToUpdate: PropTypes.func.isRequired,
	filters: PropTypes.object.isRequired
}

export default StatesForm;
